import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const ebooks = {
  state: {},
  getters: {},
  mutations: {
    null() {

    }
  },
  actions: {

    requestEbooks: ({
      commit
    }, data) => {

      console.log(data);

      return new Promise((resolve) => {
        axios.post(`/api/ebook`, data).then(response => {
          resolve(response.data);
          commit('null');
        });
      });
    }

  },
  modules: {}
}

export default ebooks;



// WEBPACK FOOTER //
// ./src/store/ebooks.js